var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"company-info",attrs:{"width":"md"}},[_c('div',{staticClass:"table-wrapper"},_vm._l((_vm.tablesItems),function(item,index){return _c('div',{key:index},[_c('h2',{staticClass:"header"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('Table',{attrs:{"table-headers":_vm.tableHeaders,"table-values":item.data}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }